import React from 'react';
import classnames from 'classnames';
import styles from './linksInAccordion.module.scss';
import newTabIcon from 'v2/icons/new-tab.svg';
import { AccordionLayout } from 'v2/common/Activity/AssociationsLayout';

export type Link = { label: string; url: string };

interface LinksInAccordionProps {
  links: Link[];
  header: string;
}

const LinksInAccordion = ({ links, header }: LinksInAccordionProps) => {
  const renderContent = () => (
    <div className="mt-4">
      {links.map((link) => (
        <div key={link.label} className={classnames('mb-2', styles.popOut)}>
          <a target="_blank" href={link.url} rel="noreferrer">
            {link.label}
          </a>
          <img src={newTabIcon} alt={'newTabIcon'} className="ml-2"></img>
        </div>
      ))}
    </div>
  );

  return (
    <AccordionLayout
      header={header}
      customStyle={styles}
      openByDefault={true}
      content={renderContent()}
    />
  );
};

export default LinksInAccordion;
